export const HrgsMasterAssessmentRoutes = (staticTitle) => {
    return [
        {
            path: '/hrgs/master-assessment',
            name: 'hrgs-master-assessment',
            meta: {
                title: `${staticTitle} - HR & GS`
            },
            component: () => {
                return import('@/views/hrgs/master-assessment/Index.vue');
            },
            children: [
                {
                    path: 'form-builder',
                    name: 'formbuilder',
                    meta: {
                        title: `${staticTitle} - HR & GS - Form Builder`
                    },
                    component: () => {
                        return import('@/views/hrgs/master-assessment/form-builder/index.vue');
                    }
                },
                {
                    path: 'asesor',
                    name: 'asesor',
                    meta: {
                        title: `${staticTitle} - HR & GS - Asesor`
                    },
                    component: () => {
                        return import('@/views/hrgs/master-assessment/assessor/AssessorList.vue');
                    }
                },
                {
                    path: 'position-mapping',
                    name: 'positionmapping',
                    meta: {
                        title: `${staticTitle} - HR & GS - Position Mapping`
                    },
                    component: () => {
                        return import('@/views/hrgs/master-assessment/position-mapping/index.vue');
                    }
                },
                {
                    path: 'assessment-schedule',
                    name: 'assessmentschedule',
                    meta: {
                        title: `${staticTitle} - HR & GS - Assessment Schedule`
                    },
                    component: () => {
                        return import('@/views/hrgs/master-assessment/assessment-schedule/AssessmentScheduleList.vue');
                    }
                },
                {
                    path: 'pre-assessment',
                    name: 'preassessment',
                    meta: {
                        title: `${staticTitle} - HR & GS - Pre Assessment Schedule`
                    },
                    component: () => {
                        return import('@/views/hrgs/master-assessment/pre-assessment/PreAssessmentScheduleList.vue');
                    }
                },
                {
                    path: 'competency-unit',
                    name: 'competencyunit',
                    meta: {
                        title: `${staticTitle} - HR & GS - Unit Competency`
                    },
                    component: () => {
                        return import('@/views/hrgs/master-assessment/competency-unit/index.vue');
                    }
                },
                {
                    path: 'schema',
                    name: 'schema',
                    meta: {
                        title: `${staticTitle} - HR & GS - Schema`
                    },
                    component: () => {
                        return import('@/views/hrgs/master-assessment/schema/index.vue');
                    }
                },
                {
                    path: 'competency-mapping',
                    name: 'competencymapping',
                    meta: {
                        title: `${staticTitle} - HR & GS - Competency Mapping`
                    },
                    component: () => {
                        return import('@/views/hrgs/master-assessment/competency-mapping/List.vue');
                    }
                },
                {
                    path: 'tuk',
                    name: 'tuk',
                    meta: {
                        title: `${staticTitle} - HR & GS - TUK`
                    },
                    component: () => {
                        return import('@/views/hrgs/master-assessment/tuk/index.vue');
                    }
                }
            ]
        }
    ];
};
export const HrgsFormBuilderRoutes = (staticTitle) => {
    return [
        {
            path: '/hrgs/master-assessment/form-builder/create',
            name: 'formbuilder-create',
            meta: {
                title: `${staticTitle} - HR & GS - Create Form Builder`
            },
            component: () => {
                return import('@/views/hrgs/master-assessment/form-builder/create.vue');
            }
        },
        {
            path: '/hrgs/master-assessment/form-builder/:id/edit',
            name: 'formbuilder-edit',
            meta: {
                title: `${staticTitle} - HR & GS - Edit Form Builder`
            },
            component: () => {
                return import('@/views/hrgs/master-assessment/form-builder/edit.vue');
            }
        }
    ];
};
export const HrgsUnitCompetencyRoutes = (staticTitle) => {
    return [
        {
            path: '/hrgs/master-assessment/competency-unit/create',
            name: 'unitcompetency-create',
            meta: {
                title: `${staticTitle} - HR & GS - Create Unit Competency`
            },
            component: () => {
                return import('@/views/hrgs/master-assessment/competency-unit/Create.vue');
            }
        },
        {
            path: '/hrgs/master-assessment/competency-unit/:id/edit',
            name: 'unitcompetency-edit',
            meta: {
                title: `${staticTitle} - HR & Edit Unit Competency`
            },
            component: () => {
                return import('@/views/hrgs/master-assessment/competency-unit/edit.vue');
            }
        }
    ];
};
